<template>
  <v-card elevation="2" id="user-pwd" :max-width="maxWidthCard" class="mx-auto mt-4 mb-3" ref="user-pwd">
    <v-card-title>
      <v-icon>mdi-information-variant</v-icon> Alterar senha</v-card-title
    >
    <v-card-text>
      <v-alert v-show="showWelcome" color="blue-grey" dark class="my-0 py-0">
        <p
          class="my-0 py-4"
          style="
            font-size: 14px;
            line-height: 18px;
            text-align: justify;
            font-weight: normal;
          "
        >
          Bem-vindo ao Pague Fácil 😊, para confirmar e finalizar sua compra
          precisamos de um pequeno cadastro para assegurar a autenticidade para
          o estabelecimento
        </p>
      </v-alert>
      <v-form>
        <v-container fluid>
          <v-row>
            <v-col cols="12" lg="4" sm="4">
              <v-text-field
                :append-icon="showPwdBdAtual ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPwdBdAtual ? 'text' : 'password'"
                @click:append="showPwdBdAtual = !showPwdBdAtual"
                v-model.trim="$v.pwd.$model"
                :error-messages="pwdError"
                prepend-icon="mdi-lock"
                disable
                name="password"
                label="Senha Atual"
              />
            </v-col>
            <v-col cols="12" lg="4" sm="4">
              <v-text-field
                :append-icon="showPwdBdNew ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPwdBdNew ? 'text' : 'password'"
                @click:append="showPwdBdNew = !showPwdBdNew"
                v-model.trim="$v.pwdNew.$model"
                :error-messages="pwdNewError"
                prepend-icon="mdi-lock"
                disable
                name="password"
                label="Nova Senha"
              />
            </v-col>
            <v-col cols="12" lg="4" sm="4">
              <v-text-field
                :append-icon="showPwdBdRepita ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPwdBdRepita ? 'text' : 'password'"
                @click:append="showPwdBdRepita = !showPwdBdRepita"
                v-model.trim="$v.repwd.$model"
                :error-messages="rePwdError"
                prepend-icon="mdi-lock"
                disable
                name="password"
                label="Repita a Senha"
              />
            </v-col>
            <v-spacer />
            <v-col cols="12" col="4" class="align-content-end">
              <v-btn
                :disabled="$v.$invalid || disableSubmit ? true : false"
                color="verde"
                dark
                class="font-weight-light"
                large
                right
                type="submit"
                @click.prevent="submit"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import { required, minLength, sameAs } from "vuelidate/lib/validators";

export default {
  name: "AlterarSenha",
  data: () => {
    return {
      showWelcome:false,
      pwd: "",
      pwdNew: "",
      repwd: "",
      showPwdBdAtual: false,
      showPwdBdNew: false,
      showPwdBdRepita: false,
      maxWidthCard: "9%",
      disableBtn: false
    };
  },
  validations: {
    pwd: {
      required
    },
    pwdNew: {
      required,
      minLength: minLength(6)
    },
    repwd: {
      required,
      sameAsPassword: sameAs("pwdNew")
    }
  },
  computed: {
    pwdError() {
      const errors = [];
      const password = this.$v.pwd;
      if (!password.$dirty) {
        return errors;
      }
      !password.required && errors.push("Senha Atual é obrigatório");
      return errors;
    },
    pwdNewError() {
      const errors = [];
      const password = this.$v.pwdNew;
      if (!password.$dirty) {
        return errors;
      }
      !password.required && errors.push("Nova Senha é obrigatório");
      !password.minLength &&
        errors.push(
          `Nova Senha deve conter ${password.$params.minLength.min} caracteres`
        );
      return errors;
    },
    rePwdError() {
      const errors = [];
      const password = this.$v.repwd;
      if (!password.$dirty) {
        return errors;
      }
      !password.required && errors.push("Nova Senha é obrigatorio");
      !password.sameAsPassword && errors.push(`As Senha devem ser iguais `);
      return errors;
    },
    disableSubmit: {
      set(value) {
        this.disableBtn = value;
      },
      get() {
        return this.disableBtn;
      }
    }
  },
  methods: {
    submit() {
      this.disableSubmit = true;
      let data = {
        hostId: this.$alertme.getHostIdUrl(this.$route),
        user: this.$store.getters.getEmail,
        pwd: this.$alertme.md5(this.pwd),
        new: this.$alertme.md5(this.pwdNew)
      };
      this.$store.commit("setRedirect", "");
      this.$alertme.changePassword(data).then(
        res => {
          this.disableSubmit = false;
          this.$store.dispatch("MsgSucces", res.data.message);
          this.$store.dispatch("displayMsgSuccess", true);
        },
        e => {
          this.disableSubmit = false;
          this.$store.dispatch("setMsgError", e.data.message);
          this.$store.dispatch("setDisplayMsgErr", true);
        }
      );
    }
  },
  props:{
    maxWidth:{
      type:String,
      default:()=> '93%'
    }
  },
  created() {
    this.maxWidthCard = !this.maxWidth ? "90%" : this.maxWidth;
    let data = {};
    data.hostId = this.$alertme.getHostIdUrl(this.$route);
    this.$alertme.getPerfil(data).then(
      res => {
        if (res.data.message != "ok") {
          this.showWelcome = true;
          this.disableTermo = false;
          this.$store.dispatch("setPerfil", {});
        } else {
          this.showWelcome = false;
          this.disableTermo = true;
          this.termo = true;
          if (
            Object.prototype.hasOwnProperty.call(res.data.value, "document")
          ) {
            this.$store.dispatch("setPerfil", res.data.value);
            let obj = this.$store.getters.getPerfil;
            let copy = Object.assign({}, this.perfil);
            this.perfil = Object.assign(copy, obj);
          }
        }
      },
      () => {
        this.$store.dispatch("setPerfil", {});
      }
    );
  }
};
</script>